module.exports = false;



//////////////////
// WEBPACK FOOTER
// ./node_modules/_core-js@2.6.11@core-js/modules/_library.js
// module id = 9v1L
// module chunks = 10